import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';

export const accommodationsConsoleTelemetry = createTelemetryObject({
  actions: {
    pageViewed: () => ({
      category: 'wedding',
      action: 'PageViewed',
      extraInfo: {
        name: 'AccommodationsConsole',
      },
    }),
  },
});

const { TelemetryProvider, useTelemetry } = createTelemetry(accommodationsConsoleTelemetry, { eventId: '', section: '' });

export { TelemetryProvider, useTelemetry as useAccommodationsConsoleTelemetry };
